import { render, staticRenderFns } from "./NotificationsComponent.vue?vue&type=template&id=1aad508c&"
import script from "./NotificationsComponent.vue?vue&type=script&lang=js&"
export * from "./NotificationsComponent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports